export default __webpack_public_path__ + "static/media/Q11.845d0535.jpg";